import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import './ArtRequestForm.scss';

export default function ArtSimFormAccess() {
  return (
    <Grid className="art-sim-request-access">
      <Grid className="access-header">
        <Typography variant="h3" gutterBottom>
          Thank you for your submission
        </Typography>
      </Grid>
      <Typography variant="h5" gutterBottom>
        Your request was successfully submitted and it’s under review by the
        Training & Scheduling Department.
      </Typography>
      <Button
        onClick={() => {
          window.location.href = '/';
        }}
        className="art-sim-request-access-button"
      >
        {' '}
        <Typography variant="h5" gutterBottom>
          Return to Home{' '}
        </Typography>
      </Button>
    </Grid>
  );
}
